import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useQuery from 'hooks/useQuery';
import Actions from 'actions';
import Selectors from 'selectors';
import { differenceInCalendarDays } from 'date-fns';
import EventCard from '../../Events/EventCard';
import { dynamicCountdown } from 'helpers/dynamicCountdown';

const UpcomingInternalEvent = () => {
  const dispatch = useDispatch();
  const params = useQuery();
  const events = useSelector(Selectors.getPaginatedEvents);
  const upcomingInternalEvents = events?.filter(
    (event) => {
      const countdownValue = dynamicCountdown(event?.start_at, event?.end_at, event?.rsvp_deadline_date)
      return event?.type === 'Event::Internal' && (countdownValue !== null || countdownValue?.status === 'rsvp_closed')
    }
  ).sort((a, b) => {
    const cdA = dynamicCountdown(a?.start_at, a?.end_at, a?.rsvp_deadline_date);
    const cdB = dynamicCountdown(b?.start_at, b?.end_at, b?.rsvp_deadline_date);

    const isRsvpOpenA = cdA?.status === 'rsvp_open';
    const isRsvpOpenB = cdB?.status === 'rsvp_open';

    if (isRsvpOpenA && !isRsvpOpenB) return -1;
    if (!isRsvpOpenA && isRsvpOpenB) return 1;
    if (isRsvpOpenA && isRsvpOpenB) {
      return new Date(a?.rsvp_deadline_date) - new Date(b?.rsvp_deadline_date);
    }

    const isHappeningNowA = cdA?.status === 'happening_now';
    const isHappeningNowB = cdB?.status === 'happening_now';

    if (isHappeningNowA && !isHappeningNowB) return -1;
    if (!isHappeningNowA && isHappeningNowB) return 1;
    if (isHappeningNowA && isHappeningNowB) {
      return new Date(a?.start_at) - new Date(b?.start_at);
    }

    return new Date(a?.start_at) - new Date(b?.start_at);
  }).slice(0, 2);


  useEffect(() => {
    dispatch(Actions.fetchEvents(params));
  }, [dispatch, params]);

  if (upcomingInternalEvents.length === 0) return null;

  return (
    <div className="container mx-auto px-6 mt-20 w-full">
      <h2 className="text-center mb-20">Upcoming Events</h2>
      <div className={`grid grid-cols-1 gap-10 w-full lg:w-3/4 xl:w-3/4 mx-auto ${upcomingInternalEvents.length === 1 ? 'place-items-center' : 'sm:grid-cols-2'}`}>
        {upcomingInternalEvents.map((item, index) => (
          <div key={item.id} className={`h-full ${upcomingInternalEvents.length === 1 ? 'w-full sm:w-1/2' : 'w-full'}`}>
            <EventCard events={item} eventsPath="/events" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingInternalEvent;